import { SearchProducts } from "@nosto/nosto-js/client"
import Button from "@/elements/Button/Button"
import Heading from "@/elements/Heading/Heading"
import style from "./Results.module.css"
import Product from "@/components/Autocomplete/DynamicCardProduct/DynamicCardProduct"
import { useOnSubmit } from "../OnSubmitContext"
import { useNostoAppState } from "@nosto/search-js/preact/hooks"
// import Product from "@/components/Autocomplete/Item/Product"

export type ProductsProps = {
  products: SearchProducts
}

export default function Products({ products }: ProductsProps) {
  const onSubmit = useOnSubmit()
  const query = useNostoAppState(state => state.query?.query || "")

  if (!products?.hits?.length) {
    return null
  }

  return (
    <div className={style.productsColumn}>
      <Heading>Products</Heading>
      <div className={style.products}>
        {products.hits.map(hit => (
          <Product key={hit.productId} hit={hit} />
        ))}
      </div>
      <div className={style.button}>
        <Button type="button" className={style.submit} onClick={() => onSubmit(query)}>
          See all search results
        </Button>
      </div>
    </div>
  )
}
